<script setup lang="ts">
import { useAuthStore } from '@/stores/auth';
import { useStudyStore } from '@/stores/study';
import { useUserStore } from '@/stores/user';
import Toast from 'primevue/toast';
const authStore = useAuthStore();
authStore.checkAuth();

const studyStore = useStudyStore();
studyStore.setStudyFromCache();

const userStore = useUserStore();
if (authStore.userLoggedIn) {
  userStore.getUser(authStore.userData!.identifier!);
}
</script>

<template>
  <Toast />
  <RouterView />
</template>

<style lang="scss">
/* Not using 'scoped' here, when using scoped properties for toast, they are not working. */
.p-toast {
  font-size: 14px;
}
.p-toast-message-text {
  margin: 0 0 0 0.5rem;
  line-height: 1.2;
}
.p-toast-summary {
  font-weight: 500;
}
.p-toast-message-icon {
  height: 16px;
  width: 16px;
}
.p-toast-detail {
  margin-top: 8px;
}
.p-toast-icon-close {
  height: 16px;
  width: 16px;
  outline-color: transparent;
}
.grecaptcha-badge { 
  visibility: hidden !important;
}
.p-galleria-close-button {
  z-index: 9999 !important;
  background-color: lightgray !important;
}
</style>
